import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c02e9768"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "My Account", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = {
  key: 0,
  style: {"list-style":"none"}
}
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Open")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service) => {
      return (_openBlock(), _createElementBlock("div", {
        key: service._id,
        class: "card"
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(service.display_name ? service.display_name : service.service_name), 1),
          (service.shortcuts)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(service.shortcuts, (s) => {
                  return (_openBlock(), _createElementBlock("li", null, [
                    _createElementVNode("a", {
                      href: s.url,
                      target: "_blank"
                    }, _toDisplayString(s.name), 9, _hoisted_7)
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            class: "btn-block btn btn-primary",
            to: service.frontend_path
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 2
          }, 1032, ["to"])
        ])
      ]))
    }), 128))
  ]))
}